import { Box } from "@mui/material";
import { type ReactNode } from "react";
import { Outlet } from "react-router-dom";

import { appFooterExternalLinks } from "~constants/appFooterExternalLinks";
import { VisitorManagementSideNav } from "~ui/organisms/VisitorManagementSideNav/VisitorManagementSideNav";
import { VisitorManagementTopBar } from "~ui/organisms/VisitorManagementTopBar/VisitorManagementTopBar";
import { Footer } from "~ui/templates/AppNavigationLayoutTemplate/NavigationMenu/Footer/Footer";

export interface VisitorManagementShellTemplateProps {
  isKioskLayout: boolean;
  logoHeight: string;
  onEmergency: () => void;
  quickResponseModal: ReactNode;
  schoolId: string | undefined;
  schoolName: string;
}

export function VisitorManagementShellTemplate({
  isKioskLayout,
  logoHeight,
  onEmergency,
  quickResponseModal,
  schoolId,
  schoolName,
}: VisitorManagementShellTemplateProps) {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {quickResponseModal}
      <VisitorManagementTopBar
        isKioskLayout={isKioskLayout}
        logoHeight={logoHeight}
        schoolId={schoolId}
        schoolName={schoolName}
        onEmergency={onEmergency}
      />
      {isKioskLayout ? (
        <Box
          component="main"
          sx={{
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            minHeight: 0,
            minWidth: 0,
            overflow: "hidden",
            overscrollBehavior: "contain",
            p: { sm: 3, xs: 2 },
          }}
        >
          <Outlet />
        </Box>
      ) : (
        <Box sx={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden" }}>
          <Box
            sx={{
              alignSelf: "stretch",
              bgcolor: (theme) => theme.palette.brand.grey[200].main,
              display: "flex",
              flexDirection: "column",
              flexShrink: 0,
              minHeight: 0,
              overflow: "hidden",
              width: 288,
            }}
          >
            <VisitorManagementSideNav />
            <Box sx={{ flexShrink: 0 }}>
              <Footer
                externalLinksProps={{ links: appFooterExternalLinks }}
                slotProps={{
                  contentContainerProps: { padding: "1rem" },
                  dividerContainerProps: { padding: "1rem 1rem 0" },
                }}
              />
            </Box>
          </Box>
          <Box
            component="main"
            sx={{
              bgcolor: (theme) => (theme.palette.mode === "light" ? "grey.50" : "background.default"),
              flex: "1 1 auto",
              minHeight: 0,
              minWidth: 0,
              overflow: "auto",
              overscrollBehavior: "contain",
              p: 3,
            }}
          >
            <Outlet />
          </Box>
        </Box>
      )}
    </Box>
  );
}
